/* eslint-disable import/prefer-default-export */
import {
  ADD_SHP_DATA_REQUEST,
  ADD_SHP_DATA_SUCCESS,
  ADD_SHP_DATA_FAILURE,
  ADD_GML_DATA_REQUEST,
  ADD_GML_DATA_SUCCESS,
  ADD_GML_DATA_FAILURE,
  ADD_CSV_DATA_REQUEST,
  ADD_CSV_DATA_SUCCESS,
  ADD_CSV_DATA_FAILURE,
  ADD_SQLITE_DATA_REQUEST,
  ADD_SQLITE_DATA_SUCCESS,
  ADD_SQLITE_DATA_FAILURE,
  ADD_APPROVED_SQLITE_DATA_REQUEST,
  ADD_APPROVED_SQLITE_DATA_SUCCESS,
  ADD_APPROVED_SQLITE_DATA_FAILURE,
  FETCH_JOB_STATUS_REQUEST,
  FETCH_JOB_STATUS_SUCCESS,
  FETCH_JOB_STATUS_FAILURE,
  FETCH_POIS_REQUEST,
  FETCH_POIS_SUCCESS,
  FETCH_POIS_FAILURE,
  FETCH_HOTELS_REQUEST,
  FETCH_HOTELS_SUCCESS,
  FETCH_HOTELS_FAILURE,
  FETCH_POIS_PROPS_REQUEST, //fetches proposed pois
  FETCH_POIS_PROPS_SUCCESS,
  FETCH_POIS_PROPS_FAILURE,
  FETCH_HOTELS_PROPS_REQUEST, //fetches proposed hotels
  FETCH_HOTELS_PROPS_SUCCESS,
  FETCH_HOTELS_PROPS_FAILURE,
  POST_NEW_POI_REQUEST,
  POST_NEW_POI_SUCCESS,
  POST_NEW_POI_FAILURE,
  UPDATE_NEW_POI_REQUEST,
  UPDATE_NEW_POI_SUCCESS,
  UPDATE_NEW_POI_FAILURE,
  SAVE_NEW_POI_REQUEST,
  SAVE_NEW_POI_SUCCESS,
  SAVE_NEW_POI_FAILURE,
  DELETE_NEW_POI_REQUEST,
  DELETE_NEW_POI_SUCCESS,
  DELETE_NEW_POI_FAILURE,
  POST_NEW_HOTEL_REQUEST,
  POST_NEW_HOTEL_SUCCESS,
  POST_NEW_HOTEL_FAILURE,
  UPDATE_NEW_HOTEL_REQUEST,
  UPDATE_NEW_HOTEL_SUCCESS,
  UPDATE_NEW_HOTEL_FAILURE,
  DELETE_NEW_HOTEL_REQUEST,
  DELETE_NEW_HOTEL_SUCCESS,
  DELETE_NEW_HOTEL_FAILURE,
  SAVE_NEW_HOTEL_REQUEST,
  SAVE_NEW_HOTEL_SUCCESS,
  SAVE_NEW_HOTEL_FAILURE,
  FETCH_PARCEL_ID_REQUEST,
  FETCH_PARCEL_ID_SUCCESS,
  FETCH_PARCEL_ID_FAILURE,
  TOGGLE_ADDITIONALS,
  DISABLE_ADDITIONALS,
  SUBMIT_ADV_SEARCH_REQUEST,
  SUBMIT_ADV_SEARCH_SUCCESS,
  SUBMIT_ADV_SEARCH_FAILURE,
  DELETE_FORM_ATTR_REQUEST,
  DELETE_FORM_ATTR_SUCCESS,
  DELETE_FORM_ATTR_FAILURE,
  UPDATE_FORM_ATTR_REQUEST,
  UPDATE_FORM_ATTR_SUCCESS,
  UPDATE_FORM_ATTR_FAILURE,
  UPLOAD_PARCEL_SUCCESS,
} from '../constants';
import fetch from '../core/fetch';
import { resetAddPoiTool } from './mapTools';

export function postSHPinZIP(prefix, layer, epsg, file) {
  return dispatch => {
    dispatch({ type: ADD_SHP_DATA_REQUEST });
    const formData = new FormData();
    formData.append('zip', file);
    return fetch(process.env.API_URL + '/district/' + prefix + '/postdata/shp?layerName=' + layer + '&EPSG=' + epsg, {
      method: 'POST',
      body: formData,
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: ADD_SHP_DATA_SUCCESS, payload: response });
      return response;
    })
    .catch((error) => {
      dispatch({ type: ADD_SHP_DATA_FAILURE });
      throw error;
    });
  };
};

export function postSHPfiles(prefix, layer, epsg, shp, shx, dbf) {
  return dispatch => {
    dispatch({ type: ADD_SHP_DATA_REQUEST });
    const formData = new FormData();
    formData.append('shp', shp);
    formData.append('shx', shx);
    formData.append('dbf', dbf);
    return fetch(process.env.API_URL + '/district/' + prefix + '/postdata/shp?layerName=' + layer + '&EPSG=' + epsg, {
      method: 'POST',
      body: formData,
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: ADD_SHP_DATA_SUCCESS, payload: response });
      return response;
    })
    .catch((error) => {
      dispatch({ type: ADD_SHP_DATA_FAILURE });
      throw error;
    });
  };
};


export function getPostSHPStatus(taskId) {
  return dispatch => {
    dispatch({ type: FETCH_JOB_STATUS_REQUEST });
    return fetch(process.env.API_URL + '/service/status/' + taskId, {
      method: 'GET',
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: FETCH_JOB_STATUS_SUCCESS });
      return response;
    })
    .catch((error) => {
      dispatch({ type: FETCH_JOB_STATUS_FAILURE });
      //throw error;
    });
  };
};

export function postGML(prefix, layer, epsg, gml, gfs) {
  return dispatch => {
    dispatch({ type: ADD_GML_DATA_REQUEST });
    const formData = new FormData();
    formData.append('gml', gml);
    formData.append('gfs', gfs);
    return fetch(process.env.API_URL + '/district/' + prefix + '/postdata/gml?layerName=' + layer + '&EPSG=' + epsg, {
      method: 'POST',
      body: formData,
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: ADD_GML_DATA_SUCCESS });
      return response;
    })
    .catch((error) => {
      dispatch({ type: ADD_GML_DATA_FAILURE });
      throw error;
    });
  };
};

export function postCSV(prefix, layer, epsg, csv) {
  return dispatch => {
    dispatch({ type: ADD_CSV_DATA_REQUEST });
    const formData = new FormData();
    formData.append('csv', csv);
    return fetch(process.env.API_URL + '/district/' + prefix + '/postdata/csv?layerName=' + layer + '&EPSG=' + epsg, {
      method: 'POST',
      body: formData,
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: ADD_CSV_DATA_SUCCESS });
      return response;
    })
    .catch((error) => {
      dispatch({ type: ADD_CSV_DATA_FAILURE });
      throw error;
    });
  };
};

export function postSQLite(prefix, sqlite) {
  return dispatch => {
    dispatch({ type: ADD_SQLITE_DATA_REQUEST });
    const formData = new FormData();
    formData.append('sqlite', sqlite);
    return fetch(process.env.API_URL + '/district/' + prefix + '/postdata/sqlite', {
      method: 'POST',
      body: formData,
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        throw response;
      })
      .then((response) => {
        dispatch({ type: ADD_SQLITE_DATA_SUCCESS });
        return response;
      })
      .catch((error) => {
        dispatch({ type: ADD_SQLITE_DATA_FAILURE });
        throw error;
      });
  };
}

export function postApprovedSQLite(prefix, content) {
  return dispatch => {
    dispatch({ type: ADD_APPROVED_SQLITE_DATA_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/postdata/approvedsqlite', {
      method: 'POST',
      body: content,
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        throw response;
      })
      .then((response) => {
        dispatch({ type: ADD_APPROVED_SQLITE_DATA_SUCCESS });
        return response;
      })
      .catch((error) => {
        dispatch({ type: ADD_APPROVED_SQLITE_DATA_FAILURE });
        throw error;
      });
  };
}

// Gets Poi FeatureCollection
export function getPois(prefix) {
  return dispatch => {
    const url = `${process.env.API_URL}/district/${prefix}/poi`;
    dispatch({ type: FETCH_POIS_REQUEST });
    return fetch(url, {
      method: 'GET',
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: FETCH_POIS_SUCCESS, payload: response.features.length ? response : null });
      return response;
    })
    .catch((error) => {
      dispatch({ type: FETCH_POIS_FAILURE });
      //throw error;
    });
  };
};

// Gets HOTELS FeatureCollection
export function getHotels(prefix) {
  return dispatch => {
    const url = `${process.env.API_URL}/district/${prefix}/hotele`;
    dispatch({ type: FETCH_HOTELS_REQUEST });
    return fetch(url, {
      method: 'GET',
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: FETCH_HOTELS_SUCCESS, payload: response.features.length ? response : null });
      return response;
    })
    .catch((error) => {
      dispatch({ type: FETCH_HOTELS_FAILURE });
      //throw error;
    });
  };
};

// Gets poi_propozycje FeatureCollection
export function getPoiPropozycje(prefix) {
  return dispatch => {
    const url = `${process.env.API_URL}/district/${prefix}/poi_propozycje`;
    dispatch({ type: FETCH_POIS_PROPS_REQUEST });
    return fetch(url, {
      method: 'GET',
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: FETCH_POIS_PROPS_SUCCESS, payload: response.features.length ? response : null });
      return response;
    })
    .catch((error) => {
      dispatch({ type: FETCH_POIS_PROPS_FAILURE });
      //throw error;
    });
  };
};

// Gets proposed HOTELS FeatureCollection
export function getHotelsPropozycje(prefix) {
  return dispatch => {
    const url = `${process.env.API_URL}/district/${prefix}/hotele_propozycje`;
    dispatch({ type: FETCH_HOTELS_PROPS_REQUEST });
    return fetch(url, {
      method: 'GET',
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: FETCH_HOTELS_PROPS_SUCCESS, payload: response.features.length ? response : null });
      return response;
    })
    .catch((error) => {
      dispatch({ type: FETCH_HOTELS_PROPS_FAILURE });
      //throw error;
    });
  };
};

// district/<string:prefix>/poi
export function postPoi(prefix, data) {
  return dispatch => {
    dispatch({ type: POST_NEW_POI_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/poi_propozycje', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: POST_NEW_POI_SUCCESS, payload: response });
    })
    .catch((error) => {
      dispatch({ type: POST_NEW_POI_FAILURE });
    });
  };
};

// UPDATE_NEW_POI_REQUEST
// UPDATE_NEW_POI_SUCCESS
// UPDATE_NEW_POI_FAILURE
export function updatePoi(prefix, data) {
  return dispatch => {
    dispatch({ type: UPDATE_NEW_POI_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/poi_propozycje', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: UPDATE_NEW_POI_SUCCESS, payload: response });
    })
    .catch((error) => {
      dispatch({ type: UPDATE_NEW_POI_FAILURE });
    });
  };
};

// DELETE_NEW_POI_REQUEST
// DELETE_NEW_POI_SUCCESS
// DELETE_NEW_POI_FAILURE
export function deletePoi(prefix, id) {
  return dispatch => {
    dispatch({ type: DELETE_NEW_POI_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/delete_poi?id=' + id, {
      method: 'DELETE',
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: DELETE_NEW_POI_SUCCESS, payload: response });
    })
    .catch((error) => {
      dispatch({ type: DELETE_NEW_POI_FAILURE });
    });
  };
};

// SAVE_NEW_POI_REQUEST
// SAVE_NEW_POI_SUCCESS
// SAVE_NEW_POI_FAILURE
export function savePoi(prefix, id) {
  return dispatch => {
    dispatch({ type: SAVE_NEW_POI_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/save_poi?id=' + id, {
      method: 'POST',
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: SAVE_NEW_POI_SUCCESS, payload: response });
    })
    .catch((error) => {
      dispatch({ type: SAVE_NEW_POI_FAILURE });
    });
  };
};

export function postHotel(prefix, data) {
  return dispatch => {
    dispatch({ type: POST_NEW_HOTEL_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/hotele_propozycje', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: POST_NEW_HOTEL_SUCCESS, payload: response });
    })
    .catch((error) => {
      dispatch({ type: POST_NEW_HOTEL_FAILURE });
    });
  };
};

// UPDATE_NEW_HOTEL_REQUEST
// UPDATE_NEW_HOTEL_SUCCESS
// UPDATE_NEW_HOTEL_FAILURE
export function updateHotel(prefix, data) {
  return dispatch => {
    dispatch({ type: UPDATE_NEW_HOTEL_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/hotele_propozycje', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: UPDATE_NEW_HOTEL_SUCCESS, payload: response });
    })
    .catch((error) => {
      dispatch({ type: UPDATE_NEW_HOTEL_FAILURE });
    });
  };
};

// DELETE_NEW_HOTEL_REQUEST
// DELETE_NEW_HOTEL_SUCCESS
// DELETE_NEW_HOTEL_FAILURE
export function deleteHotel(prefix, id) {
  return dispatch => {
    dispatch({ type: DELETE_NEW_HOTEL_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/delete_hotele?id=' + id, {
      method: 'DELETE',
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: DELETE_NEW_HOTEL_SUCCESS, payload: response });
    })
    .catch((error) => {
      dispatch({ type: DELETE_NEW_HOTEL_FAILURE });
    });
  };
};


// SAVE_NEW_HOTEL_REQUEST
// SAVE_NEW_HOTEL_SUCCESS
// SAVE_NEW_HOTEL_FAILURE
export function saveHotel(prefix, id) {
  return dispatch => {
    dispatch({ type: SAVE_NEW_HOTEL_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/save_hotele?id=' + id, {
      method: 'POST',
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: SAVE_NEW_HOTEL_SUCCESS, payload: response });
    })
    .catch((error) => {
      dispatch({ type: SAVE_NEW_HOTEL_FAILURE });
    });
  };
};

export function submitAdvSearch(prefix, layerName, attrName, opValue, formValue) {
  return dispatch => {
    dispatch({ type: SUBMIT_ADV_SEARCH_REQUEST });
    return fetch(`${process.env.API_URL}/district/${prefix}/${layerName}/${attrName}?op=${opValue}&value=${formValue}`,
      //return fetch(process.env.API_URL + '/district/gmina_cieszanow/decyzje/wnioski_rejestr?op=equal&value=54,
      { method: 'GET' },
    ).then(response => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    }).then(resp => {
      dispatch({ type: SUBMIT_ADV_SEARCH_SUCCESS, payload: resp });
      return resp;
    })
      .catch(error => {
        dispatch({ type: SUBMIT_ADV_SEARCH_FAILURE });
        throw error;
      });
  };
}

export function fetchParcelById(id, prefix) {
  return dispatch => {
    dispatch({ type: FETCH_PARCEL_ID_REQUEST })
    if (prefix != null && id != null)
      return fetch(process.env.API_URL + '/district/' + prefix + '/parcel?id=' + id,
      //return fetch(process.env.API_URL + '/district/gmina_cieszanow/parcel?id=' + id,
        { method: 'GET' }
      ).then(response => {
        if (response.status === 200) {
          return response.json();
        }
        throw response;
      }).then(resp => {
        dispatch({ type: FETCH_PARCEL_ID_SUCCESS, payload: resp, id: id });
        return resp;
      })
        .catch(error => {
          dispatch({ type: FETCH_PARCEL_ID_FAILURE });
          throw error;
        });
  };
}

export function uploadParcel(data) {
  return dispatch => { dispatch({ type: UPLOAD_PARCEL_SUCCESS, payload: data }); };
}

export function toggleAdditionals(layerName) {
  return ({ type: TOGGLE_ADDITIONALS, payload: { layerName } });
}

export function disableAdditionals() {
  return ({ type: DISABLE_ADDITIONALS });
}

export function deleteFormAttr(prefix, table, id) {
  return dispatch => {
    dispatch({ type: DELETE_FORM_ATTR_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/' + table + '/delete_formattr?id=' + id, {
      method: 'DELETE',
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: DELETE_FORM_ATTR_SUCCESS, payload: response });
    })
    .catch((error) => {
      dispatch({ type: DELETE_FORM_ATTR_FAILURE });
    });
  };
};

export function updateFormAttr(prefix, table, data) {
  return dispatch => {
    dispatch({ type: UPDATE_FORM_ATTR_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/' + table + '/update_formattr', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: UPDATE_FORM_ATTR_SUCCESS, payload: response });
    })
    .catch((error) => {
      dispatch({ type: UPDATE_FORM_ATTR_FAILURE });
    });
  };
};



// WEBPACK FOOTER //
// src/actions/postGeoData.js